// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-btn-template {
  background-color: #F40 !important;
  border-color: none !important;
  border-radius: 5px !important;
  color: #fff !important;
  width: fit-content;
}



.copy-btn {
  border-color: none !important;
  border-radius: 5px !important;
  color: #F40 !important;
  width: fit-content;
  font-size: 14px;
}



.radio-btn {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}

.radio-btn:checked::before {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #F40;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.table-container {}

.copy-label {
  color: #23282C !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 24px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/BluckEmail/BulkEmail.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;AACpB;;;;AAIA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;;;AAIA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,kBAAkB;;AAElB;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":[".submit-btn-template {\n  background-color: #F40 !important;\n  border-color: none !important;\n  border-radius: 5px !important;\n  color: #fff !important;\n  width: fit-content;\n}\n\n\n\n.copy-btn {\n  border-color: none !important;\n  border-radius: 5px !important;\n  color: #F40 !important;\n  width: fit-content;\n  font-size: 14px;\n}\n\n\n\n.radio-btn {\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ccc;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n}\n\n.radio-btn:checked::before {\n  content: \"\";\n  display: block;\n  width: 10px;\n  height: 10px;\n  background-color: #F40;\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.table-container {}\n\n.copy-label {\n  color: #23282C !important;\n  font-family: 'Noto Sans', sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  line-height: 24px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
